import { render, staticRenderFns } from "./FooterPC.vue?vue&type=template&id=d5db8662&scoped=true"
import script from "./FooterPC.vue?vue&type=script&lang=js"
export * from "./FooterPC.vue?vue&type=script&lang=js"
import style0 from "./FooterPC.vue?vue&type=style&index=0&id=d5db8662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5db8662",
  null
  
)

export default component.exports